import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plane, Heart, ArrowRight } from "lucide-react";
import { api } from "../../lib/api";
import { assetHref } from "../../lib/sky";
import { SkyBackdrop } from "../sky/SkyBackdrop";

const useFeatured = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/adventures/featured").then(({ data }) => setD(data.destination)).catch(() => {}); }, []);
  return d;
};

// Compact SKY feature inside the homepage content (below the three doors) — supports the Kingdom, doesn't dominate it.
export function SkyFeature({ dest }) {
  if (!dest) return null;
  const to = `/adventures/${dest.slug}`;
  return (
    <section className="max-w-6xl mx-auto px-6 pt-12 md:pt-14" data-testid="home-sky-feature">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
        className="relative overflow-hidden rounded-[2rem] bg-[#BFE6FF] border-[5px] border-white shadow-[0_16px_36px_rgba(31,120,180,0.16)] p-6 sm:p-8 grid sm:grid-cols-[1fr_auto] gap-6 items-center">
        <SkyBackdrop />
        <div className="relative">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/85 px-3.5 py-1 font-display font-semibold text-xs text-[#1F6FA8]"><Plane size={14} /> New free adventure · featuring {dest.setting_name} <Heart size={12} fill="#E8435A" className="text-[#E8435A]" /></span>
          <h2 className="mt-3 font-display font-black text-2xl sm:text-3xl text-ink leading-tight" data-testid="home-sky-headline">Your Great Big SKY Adventure Starts Here!</h2>
          <p className="mt-2 text-ink/75 max-w-xl text-sm sm:text-base" data-testid="home-sky-title">Color, play and explore kindness in the sky with Sir Gingerman: 16 activities and printable pages, free for every family.</p>
          <div className="mt-5 flex flex-wrap gap-3">
            <Link to={to} data-testid="home-sky-explore-btn" className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-full bg-[#1F78B4] text-white font-display font-bold px-5 py-3 shadow-[0_5px_0_#155a88] hover:-translate-y-0.5 transition-transform focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#1F78B4]/50 focus-visible:ring-offset-2"><Plane size={17} /> Explore the SKY Adventure <ArrowRight size={16} /></Link>
          </div>
          <p className="mt-3 text-xs font-bold text-ink/55">No sign-up needed.{dest.preview ? " · PRIVATE PREVIEW (not public yet)" : ""}</p>
        </div>
        <Link to={to} tabIndex={-1} aria-hidden className="relative justify-self-center hidden sm:block">
          <img src={assetHref("/printables/front-cover/display")} alt="" loading="lazy"
            className="w-32 sm:w-40 md:w-44 rotate-3 rounded-2xl border-[5px] border-white shadow-[0_16px_32px_rgba(31,120,180,0.28)]"
            onError={(e) => { e.currentTarget.style.display = "none"; }} />
        </Link>
      </motion.div>
    </section>
  );
}

export function useSkyFeatured() { return useFeatured(); }
